import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import GameProviderCard from '@/components/shared/card/GameProviderCard';
import { useSelector } from 'react-redux';
import { selectGameProviders } from '@/store/selectors/gamesSelectors';
import { thailandTopGameProvidersSlugs } from '@/constants/constants-thailand';

function Providers() {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const providers = useSelector(selectGameProviders(thailandTopGameProvidersSlugs));
  // style matching Game Category Content page
  return (
    <div className="mx-auto max-w-container py-16 px-[16px] lg:px-[32px]">
      <div className="flex justify-between items-end pb-[16px] sm:pb-[32px]">
        <div>
          <h1 className="m-0 p-0 text-[22px] sm:text-[28px]">
            {intl.formatMessage({ id: 'providers.all-game-providers.header' })}
          </h1>
          <p className="m-0 p-0 hidden sm:block font-bold opacity-50 text-[15px] sm:text-[17px] sm:mt-[8px]">
            {intl.formatMessage({ id: 'providers.all-game-providers.description' })}
          </p>
        </div>
        <span className="text-[16px] font-bold leading-[1.2] sm:text-[18px]">
          {providers.length} &nbsp;{intl.formatMessage({ id: 'header.providers' })}
        </span>
      </div>
      <div
        className={classNames(
          'w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6',
          'gap-y-12 gap-x-4 xs:gap-y-8',
        )}
      >
        {providers.map(provider => (
          <div key={`games-providers-${provider}`}>
            <GameProviderCard slug={provider} onClick={() => navigate(`/games/${provider}`)} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Providers;
